<div class="text-sm w-full mb-3.5">
    <div class="flex justify-center pt-10" *ngIf="loading">
        <app-spinner [onlySVG]="true"></app-spinner>
    </div>

    <div class="lg:table border-collapse table-list w-full" *ngIf="productStock?.length && !loading">
        <div class="hidden lg:table-header-group rounded-t-lg">
            <div class="table-row sticky top-0 bg-white text-xs font-bold uppercase bg-info border-b border-info text-left">
                <div class="table-cell py-3 px-2">{{ 'product_stock_store' | translate }}</div>
                <ng-container *ngIf="empresa === userService.empresaMarroqui && isComercial">
                    <div class="table-cell py-3 px-2">Réel</div>
                    <div class="table-cell py-3 px-2">Réservé</div>
                    <div class="table-cell py-3 px-2">En instance</div>
                </ng-container>
                <div class="table-cell py-3 px-2 text-right">{{ 'product_stock_availability' | translate }}</div>
                <div class="table-cell py-3 px-2">{{ 'product_stock_delivery' | translate }}</div>
                <div class="table-cell py-3 hidden md:table-cell"></div>
            </div>
        </div>

        <div class="lg:table-row-group align-top">
            <!-- Row -->
            <div *ngFor="let stock of productStock" class="grid sm:grid-cols-2 py-2 lg:py-0 lg:table-row border-b border-info hover:bg-select-row">
                <div class="lg:table-cell py-1 lg:py-5 px-2 lg:pr-3">
                    <div class="text-xs font-semibold lg:hidden">{{ 'product_stock_store' | translate }}:</div>
                    <div>{{ stock.nombre | titleCase }}</div>
                </div>
                <ng-container *ngIf="empresa === userService.empresaMarroqui && isComercial">
                    <div class="lg:table-cell py-1 lg:py-5 px-2 lg:px-3 lg:text-right">
                        <div class="text-xs font-semibold lg:hidden">Réel:</div>
                        <div>{{ stock.stockResA }}</div>
                    </div>
                    <div class="lg:table-cell py-1 lg:py-5 px-2 lg:px-3 lg:text-right">
                        <div class="text-xs font-semibold lg:hidden">Réservé:</div>
                        <div>{{ stock.stockRes }}</div>
                    </div>
                    <div class="lg:table-cell py-1 lg:py-5 px-2 lg:px-3 lg:text-right">
                        <div class="text-xs font-semibold lg:hidden">En instance:</div>
                        <div>{{ stock.stockPendiente }}</div>
                    </div>
                </ng-container>
                <div class="lg:table-cell py-1 lg:py-5 px-2 lg:px-3 lg:text-right">
                    <div class="text-xs font-semibold lg:hidden">{{ 'product_stock_availability' | translate }}:</div>
                    <div>{{stock.stockMostrar}}</div>
                </div>
                <div class="col-span-2 lg:table-cell py-1 px-2 lg:py-5 lg:px-3 lg:pr-2">
                    <div class="text-xs font-semibold mb-2 lg:hidden">{{ 'product_stock_delivery' | translate }}:</div>
                    <div class="flex flex-wrap md:flex-no-wrap items-start gap-3 md:gap-7">
                        <div [ngClass]="{'bg-success text-white': stock.colorEntrega === 1, 'bg-warning-light text-warning': stock.colorEntrega === 2, 'bg-featured-light text-featured': stock.colorEntrega === 3}" class="flex items-center gap-3 w-fit h-fit rounded px-3 py-1.5 whitespace-no-wrap">
                            <svg [ngClass]="{'fill-white': stock.colorEntrega === 1, 'fill-warning': stock.colorEntrega === 2 ,'fill-featured': stock.colorEntrega === 3}" width="16" height="16" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.22961 4.85805C0.711792 4.85805 0.292114 5.26167 0.292114 5.75969C0.292114 6.2577 0.711975 6.66133 1.22961 6.66133H8.93158L7.46765 8.0476C7.09869 8.39681 7.09412 8.96773 7.4574 9.32258C7.64087 9.50185 7.88312 9.59166 8.12537 9.59166C8.36285 9.59166 8.60052 9.50554 8.78308 9.33261L10.852 7.37366C11.3 6.94925 11.5469 6.38414 11.5469 5.78205C11.5469 5.18014 11.3 4.61485 10.852 4.19045L8.73584 2.18676C8.36688 1.83755 7.77325 1.84196 7.40997 2.1968C7.04669 2.55165 7.05145 3.12257 7.42041 3.47195L8.88434 4.85805H1.22961ZM21.3817 14.5428L20.845 11.9162C20.6979 11.179 20.4442 10.616 20.0695 10.1953C19.5863 9.65294 18.9086 9.36625 18.1094 9.36625H15.9062V5.75511C15.9062 5.25709 15.4866 4.85347 14.9688 4.85347C14.4509 4.85347 14.0312 5.25709 14.0312 5.75511V14.5056H4.9375C4.41968 14.5056 4 14.9092 4 15.4072C4 15.9053 4.41968 16.3089 4.9375 16.3089H20.7812C21.6678 16.4064 22.375 17.0985 22.375 17.9769V20.3212H20.3387C19.9518 19.2718 18.9097 18.5179 17.6875 18.5179C16.4653 18.5179 15.4232 19.2718 15.0363 20.3212H9.22931C8.84241 19.2718 7.80035 18.5179 6.57812 18.5179C5.35663 18.5179 4.31512 19.2709 3.92749 20.3194C2.92719 20.2826 2.125 19.4889 2.125 18.5179V9.36167C2.125 8.86365 1.70532 8.46003 1.1875 8.46003C0.669678 8.46003 0.25 8.86365 0.25 9.36167V18.5179C0.25 20.4828 1.89246 22.0847 3.92621 22.1227C4.31274 23.173 5.35535 23.9277 6.57812 23.9277C7.80035 23.9277 8.84241 23.1738 9.22931 22.1245H15.0363C15.4232 23.1738 16.4653 23.9277 17.6875 23.9277C18.9097 23.9277 19.9518 23.1738 20.3387 22.1245H23.3125C23.8303 22.1245 24.25 21.7208 24.25 21.2228V17.9769C24.25 16.2981 23.0203 14.8902 21.3817 14.5428ZM15.9062 11.1695H18.1094C18.3956 11.1695 18.7874 11.1695 19.0038 12.2577L19.0046 12.2612L19.0048 12.2621L19.4633 14.5056H15.9062V11.1695ZM5.64062 21.2228C5.64062 21.7199 6.06122 22.1245 6.57812 22.1245C7.09503 22.1245 7.51562 21.7199 7.51562 21.2228C7.51562 20.7257 7.09503 20.3212 6.57812 20.3212C6.06122 20.3212 5.64062 20.7257 5.64062 21.2228ZM17.6875 22.1245C17.1706 22.1245 16.75 21.7199 16.75 21.2228C16.75 20.7257 17.1706 20.3212 17.6875 20.3212C18.2044 20.3212 18.625 20.7257 18.625 21.2228C18.625 21.7199 18.2044 22.1245 17.6875 22.1245Z" />
                            </svg>
                            <span class="text-xs font-medium">
                                <span *ngIf="isToday(stock.entrega)">
                                    {{'stockHoy' | translate }}
                                </span>
                                <span *ngIf="isTomorrow(stock.entrega)">
                                    {{'stockMañana' | translate }}
                                </span>
                                <span *ngIf="!isToday(stock.entrega) && !isTomorrow(stock.entrega)">
                                    {{stock.entrega}}
                                </span>
                            </span>
                        </div>
                        <div class="lg:hidden text-xs">
                            <p>
                                {{'product_stock_receive'|translate}}
                                <span>
                                    <span *ngIf="isToday(stock.entrega)">
                                        {{'stockHoy' | translate }}
                                    </span>
                                    <span *ngIf="isTomorrow(stock.entrega)">
                                        {{'stockMañana' | translate }}
                                    </span>
                                    <span *ngIf="!isToday(stock.entrega) && !isTomorrow(stock.entrega)">
                                        {{stock.entrega}}
                                        {{'product_stock_until'| translate}}
                                    </span>
                                    <span translate
                                        [translateParams]="{ Count: stock.stockMostrar }">product_stock_units</span>
                                </span>
                            </p>
                            <p>
                                <span *ngIf="stock.fechaHoraCorte">
                                    {{'product_stock_before_hour'|translate}}
                                    {{
                                        stock.horaCorte
                                    }}
                                    <span *ngIf="today !== stock.fechaCorte">{{
                                        getDateFormated(stock.fechaCorte)
                                        }}</span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="hidden lg:table-cell py-5 align-top">
                    <div class="text-xs">
                        <p>
                            {{'product_stock_receive'|translate}}
                            <strong>
                                <span *ngIf="isToday(stock.entrega)">
                                    {{'stockHoy' | translate }}
                                </span>
                                <span *ngIf="isTomorrow(stock.entrega)">
                                    {{'stockMañana' | translate }}
                                </span>
                                <span *ngIf="!isToday(stock.entrega) && !isTomorrow(stock.entrega)">
                                    {{stock.entrega}}
                                    {{'product_stock_until'| translate}}
                                </span>
                                <span translate
                                    [translateParams]="{ Count: stock.stockMostrar }">product_stock_units</span>
                            </strong>
                        </p>
                        <p>
                            <span *ngIf="stock.fechaHoraCorte">
                                {{'product_stock_before_hour'|translate}}
                                {{
                                    stock.horaCorte
                                }}
                                <span *ngIf="today !== stock.fechaCorte">{{
                                    getDateFormated(stock.fechaCorte)
                                    }}</span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <!-- END Row -->
        </div>
    </div>

    <app-alert-text *ngIf="!loading && (!productStock.length)" type="error">{{ 'common_no_results' | translate }}</app-alert-text>
</div>
